import React from "react";

const DATE_FIELDS = [
  'requestedDeliveryDate', 'appointmentPickupDate', 'appointmentDeliveryDate',
  'availableDate1', 'availableDate2', 'pickupDate',
  'deliveryDate', 'destAvailableDate1', 'destAvailableDate2', 'estimatedPickup'
];

const DELIVERY_DATE_FIELDS = [
  'requestedDeliveryDate', 'appointmentDeliveryDate', 'deliveryDate'
];

const anyDateInPast = (dates) =>
  DATE_FIELDS.some(f => dates?.[f] && new Date(dates[f]) < new Date());

const anyDeliveryDateInPast = (dates) =>
  DELIVERY_DATE_FIELDS.some(f => dates?.[f] && new Date(dates[f]) < new Date());

const WhatsMissingListAurora = ({ shipment, showFields }) => {
  if (shipment?.customerId !== "aurora") return null;
  if (!showFields?.includes("WhatsMissingListAurora")) return null;

  const { dates, status, charges, documents } = shipment;
  const datesInPast = anyDateInPast(dates);
  const deliveryDatesInPast = anyDeliveryDateInPast(dates);

  const missing = [];

  // Rule 1: past delivery date and not yet marked delivered
  if (deliveryDatesInPast && status?.statusId !== "DEL") {
    missing.push("Shipment has a past delivery date but has not been marked as Delivered");
  }

  // Rule 2: missing invoice number or tracking number
  if (!charges?.invoiceNumber && !charges?.trackingNumber) {
    missing.push("Missing invoice number or tracking number");
  }

  // Rule 3: missing required documents
  const hasSignedBOLAndInvoice = documents?.some(d => d.type?.toLowerCase() === "signed-bolandinvoice");
  const hasSignedBOL = documents?.some(d => d.type?.toLowerCase() === "signed-bol");
  const hasInvoice = documents?.some(d => d.type?.toLowerCase() === "invoice");
  if (!hasSignedBOLAndInvoice && !(hasSignedBOL && hasInvoice)) {
    missing.push("Missing required documents — upload a Signed BOL and Invoice (or combined Signed-BOL-and-Invoice)");
  }

  // Rule 4: no pickup or delivery date recorded
  if (!dates?.pickupDate && !dates?.deliveryDate) {
    missing.push("Missing pickup date and delivery date");
  }

  // Future shipment with nothing missing — nothing meaningful to show yet
  if (missing.length === 0 && !datesInPast && !deliveryDatesInPast) return null;

  if (missing.length === 0) return (
    <div style={{
      backgroundColor: "#f1f8e9",
      border: "1px solid #7cb342",
      borderRadius: "4px",
      padding: "8px 14px",
      margin: "8px 0 12px 0",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "13px",
      color: "#33691e",
      fontWeight: 600,
    }}>
      ✓ All billing requirements met
    </div>
  );

  return (
    <div style={{
      backgroundColor: "#fff8e1",
      border: "1px solid #f9a825",
      borderRadius: "4px",
      padding: "10px 14px",
      margin: "8px 0 12px 0",
    }}>
      <div style={{ fontWeight: 600, fontSize: "13px", marginBottom: "6px", color: "#5d4037" }}>
        Action Required
      </div>
      <ul style={{ margin: 0, paddingLeft: "18px", fontSize: "13px", color: "#4e342e" }}>
        {missing.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default WhatsMissingListAurora;
